import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaWhatsapp, FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import logo from '../assets/logo.svg';
import '../styles/Footer.css';

const footerLinks = [
  { label: 'Services', path: '/services' },
  { label: 'Solutions', path: '/solutions' },
  { label: 'Products & Apps', path: '/products' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

const socialLinks = [
  { label: 'WhatsApp', href: 'https://wa.me/14376043134', icon: <FaWhatsapp /> },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/bularis-tech', icon: <FaLinkedin /> },
  { label: 'Facebook', href: 'https://www.facebook.com/bularistech', icon: <FaFacebook /> },
  { label: 'Instagram', href: 'https://www.instagram.com/bularistech/', icon: <FaInstagram /> },
  { label: 'X', href: 'https://x.com/bularistech', icon: <FaXTwitter /> },
];

const legalLinks = [
  { label: 'Privacy Policy', path: '/privacy-policy' },
  { label: 'Terms of Service', path: '/terms-of-service' },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-brand-column">
          <Link to="/" className="footer-brand"><img src={logo} alt="" /><span>Bularis Tech</span></Link>
          <p>Building useful software, e-commerce systems, integrations, automation, and digital products around real business needs.</p>
          <div className="footer-socials">
            {socialLinks.map((social) => <a key={social.label} href={social.href} target="_blank" rel="noopener noreferrer" aria-label={social.label}>{social.icon}</a>)}
          </div>
        </div>

        <nav className="footer-navigation" aria-label="Footer navigation">
          <h2>Explore</h2>
          <ul>{footerLinks.map((link) => <li key={link.path}><Link to={link.path}>{link.label}</Link></li>)}</ul>
        </nav>

        <div className="footer-locations">
          <h2>Locations</h2>
          <address><FaMapMarkerAlt /><span>16 Alphonse Crescent, Mississauga, Ontario L5M 1A5, CA</span></address>
          <address><FaMapMarkerAlt /><span>201 Exford Rd, Weir Views VIC 3338 Australia</span></address>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Bularis Tech. All rights reserved.</span>
        <nav aria-label="Legal navigation">
          {legalLinks.map((link) => <Link key={link.path} to={link.path}>{link.label}</Link>)}
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
